import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/door/guestapply/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/door/guestapply/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/door/guestapply/remove', qs.stringify(params), options);

export const add = (params, options) =>
  request.post('/api/door/guestapply/submit', params, options);

export const update = (params, options) =>
  request.post('/api/door/guestapply/submit', params, options);

export const applyAudit = (params, options) =>
  request.post('/api/door/guestapply/applyAudit', params, options);
